var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyleHeader1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83993 8.75H5.06702C4.91771 8.75 4.79653 8.62882 4.79653 8.47952V5.68889C4.79653 5.53958 4.67535 5.4184 4.52604 5.4184H1.58403C1.43472 5.4184 1.31354 5.53958 1.31354 5.68889V8.47952C1.31354 8.62882 1.19236 8.75 1.04306 8.75H0.270486C0.121181 8.75 0 8.62882 0 8.47952V1.52049C0 1.37118 0.121181 1.25 0.270486 1.25H1.0434C1.19271 1.25 1.31389 1.37118 1.31389 1.52049V3.9684C1.31389 4.11771 1.43507 4.23889 1.58438 4.23889H4.52709C4.67639 4.23889 4.79757 4.11771 4.79757 3.9684V1.52049C4.79757 1.37118 4.91875 1.25 5.06806 1.25H5.84097C5.99028 1.25 6.11146 1.37118 6.11146 1.52049V8.47986C6.11146 8.62917 5.99028 8.75035 5.84097 8.75035L5.83993 8.75Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7295 8.75H8.95693C8.80763 8.75 8.68645 8.62882 8.68645 8.47952V2.70069C8.68645 2.55139 8.56527 2.43021 8.41596 2.43021H8.25242C8.10311 2.43021 7.98193 2.30903 7.98193 2.15972V1.52049C7.98193 1.37118 8.10311 1.25 8.25242 1.25H9.7295C9.87881 1.25 9.99999 1.37118 9.99999 1.52049V8.47986C9.99999 8.62917 9.87881 8.75035 9.7295 8.75035V8.75Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleHeader1Icon);
export default __webpack_public_path__ + "static/media/StyleHeader1Icon.948672ac5a2738d48bf1729be844dd45.svg";
export { ForwardRef as ReactComponent };